import * as sendData from '../api/senddata'
import * as types from '../constants/mutation-types'

export const sendMessage = ({ state, commit }, payload) => {
  sendData.sendChat(payload.text, payload.id)
  const now = new Date()//2020-11-18 11:10:01.0
  const time = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate() + ' ' + now.getHours() + ':' + now.getMinutes() + ':' + now.getSeconds()
  const messge = {id: now.getTime(), content: payload.text, author: state.userInfo.userId, roomId: payload.id,
    me: true, time: time, isRead: false, wait: true}
  commit(types.ADD_WAIT_MESSAGE, messge)
}

export const sendLogin = ({ commit }, payload) => {
  sendData.sendLogin(payload)
}

export const readMessage = ({ state, commit }, payload) => {
  const userInfo = state.userInfo
  sendData.sendReadMessage(payload.roomId, userInfo.userId, userInfo.userName)
  if (payload.roomId === -1) {
    if (state.currentThreadID) {
      commit(types.SET_UNREAD_THREAD, state.currentThreadID)
    }
  } else {
    commit(types.SET_UNREAD_THREAD, payload.roomId)
  }
}

export const incommingMessage = ({ commit }, payload) => {
  sendData.sendIncommingMessage(payload.roomId, payload.userId, payload.userName, payload.status)
}

export const sendGetHistory = ({ commit }, payload) => {
  sendData.sendHistoryChat(payload.roomId, payload.pagingStartTime, payload.pagingSize)
}

